export default {
  title: 'Select Gift',
};
